import { BaseResource } from 'utils/ApiUtils';

export default class AADUser extends BaseResource {
    constructor(args) {
      super(args, AADUser.attributes);
      this.Title = this.Title ? this.Title : '';
    }
  
    static columns = [
      {title: "Name", field: "Name", type: "string"},
      {title: "JobTitle", field: "Title", type: "string"},
      {title: "id", field: "Id", type: "string"}
    ]
  
    static attributes = AADUser.columns.map(r => r.field);
}